import { TabsModule } from 'primeng/tabs';
import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SliderModule } from 'primeng/slider';
import { TagModule } from 'primeng/tag';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { InfoService } from '../../services/info-service/info.service';
import { TableModule } from 'primeng/table';
import { Router } from '@angular/router';
import { FileUploadModule } from 'primeng/fileupload';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-gestion-info',
  imports: [
    BreadcrumbModule,
    CommonModule,
    TableModule,
    FormsModule,
    ButtonModule,
    RippleModule,
    ToastModule,
    ToolbarModule,
    RatingModule,
    InputTextModule,
    TextareaModule,
    SelectModule,
    RadioButtonModule,
    InputNumberModule,
    DialogModule,
    TagModule,
    InputIconModule,
    IconFieldModule,
    ConfirmDialogModule,
    SliderModule,
    ProgressBarModule,
    DividerModule,
    MessageModule,
    CalendarModule,
    SelectButtonModule,
    MultiSelectModule,
    DropdownModule,
    TabsModule,
    FileUploadModule

  ],
  templateUrl: './gestion-info.component.html',
  styleUrl: './gestion-info.component.scss',
  providers: [MessageService, ConfirmationService]
})
export class GestionInfoComponent {

  breadcrumbInfo = { icon: 'pi pi-home', routerLink: '/rechercher-do' };
  breadcrumbItems = [{ label: 'Gestion Info' }];

  @ViewChild('filter') filter!: ElementRef;

  activeTab: number = 0;

  do: any = JSON.parse(sessionStorage.getItem('selectedDo') || '{}').code_interne;;
  nomDo ! : string;
  agentName: string =  JSON.parse(localStorage.getItem('currentUser') || '').name;
  infos: any[] = [];
  cols: any[] = [];
  loading: boolean = false;
  selectedInfos: any[] = [];
  totalRecords: number = 0;
  rowsPerPageOptions: number[] = [10]; // Valeur par défaut
  libelleInfos: any[] = []; // Pour stocker les libellés dynamiques
  libellesValues: { [key: string]: any } = {}; // Pour stocker les sélections
  displayedColumns: any[] = [];
  showAllColumns = false;
  allColumns: any[] = [];

  addInfoDialog : boolean = false;
  updateInfoDialog : boolean = false;
  submitted: boolean = false;
  newInfoValues: { [key: string]: string } = {};
  fieldMappings: { [libelleKey: string]: string } = {}; // Pour stocker la correspondance entre libellés et champs API ADD
  infoToUpdate: any = null; // Pour stocker l'info à mettre à jour

  isDisableButton: boolean = false;
  UploadDialog: boolean = false;
  add_on: any = false;
  uploadedFiles: any[] = [];



  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private infoService: InfoService,
    private router: Router
    )
  {}

  ngOnInit(){

     const savedSelection = sessionStorage.getItem('selectedDo');
        if (!savedSelection) {
            this.router.navigate(['/rechercher-do']);
        } else {
            let selectedDo = JSON.parse(savedSelection);
            this.do = selectedDo.code_interne;
            this.nomDo = selectedDo.Nom;
        }

    this.loadInfos();
    this.loadLibelleInfos();
  }

   loadInfos() {
    this.loading = true;
    this.infoService.getAllInfos(this.do).subscribe({

      next: (data:any) => {
        this.infos = data;
        this.totalRecords = data.length;
        this.updateRowsPerPageOptions();
        //console.log('Infos chargées:', this.infos);
        this.generateDynamicColumns();
        this.loading = false;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des infos:', error);
        this.loading = false;
      }
    });
  }

  loadLibelleInfos() {
    this.infoService.getAllLibelleInfos(this.do).subscribe({
      next: (data: any) => {
        this.libelleInfos = data;

        // Vérifier si le tableau est vide
        if (this.libelleInfos.length === 0) {
          this.addEmptyRowLibelleInfo();
        }

        if (this.libelleInfos.length > 0) {
        this.allColumns = Object.keys(this.libelleInfos[0])
        .filter(key => key !== 'code_interne')
        .map(key => {

          // Créer le mapping entre les clés de libellé et les champs API
              const champNumber = key.replace('Champs', '').replace('_Libelle', '');
              this.fieldMappings[key] = `Champs${champNumber}`;

          return {
            field: key,
            label: key
          };
        });

      // Afficher seulement les 12 premières colonnes initialement
      this.displayedColumns = this.allColumns.slice(0, 12);
      this.libellesValues = {...this.libelleInfos[0]};
    }

      },
      error: (error) => {
        console.error('Erreur lors du chargement des libellés:', error);
      }
    });
  }


  // Ajoutez cette méthode pour gérer l'affichage de plus de colonnes
  toggleShowAllColumns() {
    this.showAllColumns = !this.showAllColumns;
    this.displayedColumns = this.showAllColumns
      ? this.allColumns
      : this.allColumns.slice(0, 12);
  }


  generateDynamicColumns() {
  if (this.infos.length > 0) {
    // Prenez le premier élément pour déterminer les propriétés
    const firstItem = this.infos[0];
    this.cols = Object.keys(firstItem).map(key => {
      return {
        field: key,
        header: key,
        filter: true // Active le filtrage par défaut
      };
    });

    // Ajoutez une colonne d'actions à la fin
    this.cols.push({
      field: 'actions',
      header: 'Actions',
      filter: false
    });
  }
}

updateRowsPerPageOptions() {
        const baseOptions = [10, 20, 30, 40, 50];

        // Limitez les options supplémentaires à des valeurs raisonnables
        const maxReasonableOption = 100; // Définissez une limite supérieure raisonnable

        if (this.totalRecords > 50) {
            const additionalOptions = [];
            // Ajoutez des options jusqu'à la limite raisonnable ou au totalRecords (le plus petit des deux)
            const upperLimit = Math.min(this.totalRecords, maxReasonableOption);

            for (let i = 100; i <= upperLimit; i += 100) {
                additionalOptions.push(i);
            }

            this.rowsPerPageOptions = [...baseOptions, ...additionalOptions];
        } else {
            this.rowsPerPageOptions = baseOptions;
        }

        // Ajoutez le totalRecords seulement s'il est raisonnable et différent des options existantes
        if (this.totalRecords <= maxReasonableOption &&
            !this.rowsPerPageOptions.includes(this.totalRecords)) {
            this.rowsPerPageOptions.push(this.totalRecords);
        }
    }

  getGlobalFilterFields(): string[] {
    return this.cols
      .filter(col => col.field !== 'actions')
      .map(col => col.field);
  }
  // Méthode pour le filtre global
  onGlobalFilter(table: any, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  // Méthode pour réinitialiser les filtres
  clear(table: any) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  openNewInfo(){
    this.submitted = false;
    this.addInfoDialog = true;
    this.newInfoValues = {};
  }
  openUploadDialog() {
        this.UploadDialog = true;
    }
     closeUploadDialog() {
        this.UploadDialog = false;
    }
    onUpload(event: any, uploader: any) {
        const files = event.files as File[];

        const validCsvFiles = files.filter((file: File) => {
            const isCsv = file.name.toLowerCase().endsWith('.csv');
            if (!isCsv) {
                this.messageService.add({
                    severity: 'warn',
                    summary: 'Fichier non valide',
                    detail: `Le fichier "${file.name}" n'est pas un fichier CSV.`
                });
            }
            return isCsv;
        });

        if (validCsvFiles.length === 0) {
            uploader.clear();
            return;
        }

        let completed = 0;
        let successCount = 0;
        let errorCount = 0;

        for (let file of validCsvFiles) {
            this.infoService.importCsvInfo(this.do ,this.add_on, file).subscribe({
                next: (event:any) => {
                    if (event instanceof HttpResponse) {
                        if (event.status === 201) {
                            successCount = successCount + 1
                            this.UploadDialog = false
                            this.loadInfos();
                            this.messageService.add({
                                severity: 'success',
                                summary: 'Import terminé',
                                detail: `${successCount} fichier(s) importé(s) avec succès.`
                            });
                        } else {
                            errorCount++;
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Erreur',
                                detail: `Fichier "${file.name}" : Échec d’import (code ${event.status}).`
                            });
                        }
                    }
                    checkCompletion();
                },
                error: (err:any) => {
                    errorCount++;
                    const errorMessage = err?.error?.message?.error || 'Erreur lors de l’import CSV.';
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erreur',
                        detail: `Fichier "${file.name}" : ${errorMessage}`
                    });
                    checkCompletion();
                }
            });
        }

        const checkCompletion = () => {
            completed++;
            if (completed === validCsvFiles.length) {

                uploader.clear();
            }
        };
    }
       telechargerTemplateCSV() {
    this.infoService.exportTemplateInfo().subscribe({
      next: (blob : any) => {
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = `Template_Import_Info.csv`;
        a.click();
        URL.revokeObjectURL(objectUrl);
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Template téléchargé' });
      },
      error: (err:any) => {
        console.error('Erreur lors du téléchargement :', err);
        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Téléchargement échoué' });
      },
    });
  }

  openUpdateInfo(code_interne : number) {
  this.submitted = false;
  this.updateInfoDialog = true;

  // Retrouver l'objet complet depuis la liste
  const info = this.infos.find(item => item.code_interne === code_interne);
  if (!info) return;

  // Réinitialiser les valeurs pour le formulaire
  this.newInfoValues = {};

  // Parcourir tous les libellés pour retrouver à quel champ correspond chaque libellé
  for (const [libelleKey, libelleLabel] of Object.entries(this.libellesValues)) {
    if (libelleLabel) {
      // Exemple : libelleKey = 'Champs01_Libelle', libelleLabel = 'Bailleur'
      const fieldName  = libelleLabel as string;
      this.newInfoValues[libelleKey] = info[fieldName] ?? '';
    }
  }

  // Stocker temporairement l'élément à modifier (ex: pour son code_interne)
  this.infoToUpdate = info;
}

validateAndUpdateInfo() {
  this.isDisableButton = true;
  if (!this.infoToUpdate || !this.infoToUpdate.code_interne){
    this.isDisableButton= false;
    return
  };

  const payload: any = {
    AgentModif: this.agentName
  };

  // Initialiser tous les ChampsXX à null
  for (let i = 1; i <= 60; i++) {
    const champKey = `Champs${i.toString().padStart(2, '0')}`;
    payload[champKey] = null;
  }

  // Mapper les valeurs modifiées
  for (const [libelleKey, value] of Object.entries(this.newInfoValues)) {
    if (value && this.fieldMappings[libelleKey]) {
      const trimmedValue = value.toString().trim();
      if (trimmedValue) {
        payload[this.fieldMappings[libelleKey]] = trimmedValue;
       // console.log(`Mapping ${libelleKey} to ${this.fieldMappings[libelleKey]} with value: ${trimmedValue}`);
      }
    }
  }

  //console.log('Payload update:', payload);

  this.infoService.updateInfo(this.infoToUpdate.code_interne, payload).subscribe({
    next: () => {
      this.messageService.add({
        severity: 'success',
        summary: 'Succès',
        detail: 'Info mise à jour avec succès'
      });
      this.updateInfoDialog = false;
      this.isDisableButton = false;
      this.loadInfos(); // Refresh table
    },
    error: (err) => {
      console.error('Erreur lors de la mise à jour :', err);
      this.messageService.add({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Échec de la mise à jour'
      });
      this.isDisableButton = false;
    }
  });
}


    hideDialog() {
        this.addInfoDialog = false;
        this.updateInfoDialog = false;
        this.submitted = false;
    }

    validateAndSaveInfo(){

       const payload: any = {
          code_DO: this.do,
          AgentModif: this.agentName
       };

        // Initialiser tous les champs possibles à null
      for (let i = 1; i <= 60; i++) { // Ajustez le nombre selon vos besoins
          const champKey = `Champs${i.toString().padStart(2, '0')}`;
          payload[champKey] = null;
      }

       // Transformer les données selon le mapping
      for (const [libelleKey, value] of Object.entries(this.newInfoValues)) {
          if (value && this.fieldMappings[libelleKey]) {
              const trimmedValue = value.toString().trim();
              if (trimmedValue) {
                  payload[this.fieldMappings[libelleKey]] = trimmedValue;
                 // console.log(`Mapping ${libelleKey} to ${this.fieldMappings[libelleKey]} with value: ${trimmedValue}`);
              }
          }
      }

    //console.log("test payload : ", payload);
      // Appeler le service pour ajouter l'info
      this.infoService.addInfo(payload).subscribe({
        next: () => {
          this.messageService.add({
             severity: 'success',
             summary: 'Succès',
             detail: 'Info ajoutée avec succès'
            });
          this.addInfoDialog = false;
          this.isDisableButton = false;
          this.loadInfos(); // Recharger la liste
        },
        error: (error) => {
          console.error('Erreur lors de l\'ajout:', error);
          this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Échec de l\'ajout' });
        }
      });

    }

    objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  deleteByInfo(info: any) {
    this.confirmationService.confirm({
        message: 'Souhaitez-vous vraiment supprimer cette info ?',
        header: 'Confirmer',
        icon: 'pi pi-exclamation-triangle',
        rejectButtonStyleClass: 'p-button-secondary',
        acceptLabel: 'Oui',
        rejectLabel: 'Non',
        accept: () => {
            this.infoService.deleteInfo([info.code_interne]).subscribe({
                next: () => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Succès',
                        detail: 'Info supprimée avec succès',
                        life: 3000
                    });
                    this.loadInfos(); // Recharger les données
                },
                error: (error) => {
                    console.error(error);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erreur',
                        detail: 'Échec de la suppression',
                        life: 3000
                    });
                }
            });
        }
    });
}

deleteSelectedInfos() {
    this.confirmationService.confirm({
        message: 'Souhaitez-vous vraiment supprimer les infos sélectionnées ?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        rejectButtonStyleClass: 'p-button-secondary',
        acceptLabel: 'Oui',
        rejectLabel: 'Non',
        accept: () => {
            if (!this.selectedInfos || this.selectedInfos.length === 0) {
                this.messageService.add({
                    severity: 'warn',
                    summary: 'Avertissement',
                    detail: 'Aucune info sélectionnée',
                    life: 3000
                });
                return;
            }

            const codes = this.selectedInfos.map(info => info.code_interne);
            this.infoService.deleteInfo(codes).subscribe({
                next: () => {
                    this.loadInfos();

                    this.selectedInfos = [];

                    this.messageService.add({
                        severity: 'success',
                        summary: 'Succès',
                        detail: `${codes.length} info(s) supprimée(s)`,
                        life: 3000
                    });
                },
                error: (error) => {
                    console.error('Erreur suppression:', error);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Erreur',
                        detail: 'Échec de la suppression',
                        life: 3000
                    });
                }
            });
        }
    });
}

updateLibelleInfos() {
    // Vérifier qu'il y a bien des libellés à sauvegarder
    if (!this.libelleInfos || this.libelleInfos.length === 0) {
        this.messageService.add({
            severity: 'warn',
            summary: 'Avertissement',
            detail: 'Aucun libellé à sauvegarder',
            life: 3000
        });
        return;
    }

    // Préparer les données à envoyer
   const libelleInfoToUpdate: any = {};
    for (const key in this.libellesValues) {
        if (this.libellesValues.hasOwnProperty(key)) {
            const value = this.libellesValues[key];
            libelleInfoToUpdate[key] = value ? value : null;
            //console.log(`Mapping ${key} to ${this.fieldMappings[key]} with value: ${value}`);
            //console.log("test libelleInfoToUpdate : ", libelleInfoToUpdate);
        }
    }

    // Appeler le service pour mettre à jour les libellés
    this.infoService.updateLibelleInfos(this.do, libelleInfoToUpdate).subscribe({
        next: () => {
            this.messageService.add({
                severity: 'success',
                summary: 'Succès',
                detail: 'Libellés mis à jour avec succès',
                life: 3000
            });
            this.loadLibelleInfos();
            this.loadInfos();
            this.activeTab = 0;
        },
        error: (error) => {
            console.error('Erreur lors de la mise à jour des libellés:', error);
            this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Échec de la mise à jour des libellés',
                life: 3000
            });
        }
    });
}

addEmptyRowLibelleInfo() {
  this.infoService.addEmptyRowLibelleInfos(this.do).subscribe({
    next: () => {
      this.loadLibelleInfos();
    },
    error: (error) => {
      console.error('Erreur lors de l\'ajout d\'une ligne vide:', error);
      this.loading = false;

    }
  });
}


allLibelleInfosAreNull(): boolean {
  if (!this.libellesValues) return true;

  // Vérifier tous les champs de libellé de 01 à 60
  for (let i = 1; i <= 60; i++) {
    const libelleKey = `Champs${i.toString().padStart(2, '0')}_Libelle`;
    if (this.libellesValues[libelleKey] !== null && this.libellesValues[libelleKey] !== undefined && this.libellesValues[libelleKey] !== '') {
      return false;
    }
  }
  return true;
}

cancelLibelleChanges(){
  this.activeTab = 1;
  this.loadLibelleInfos();
  this.libellesValues = {...this.libelleInfos[0]};
  this.messageService.add({
    severity: 'info',
    summary: 'Annulation',
    detail: 'Les modifications des libellés ont été annulées'
  });
}

}
